var React = require('react');

function DiningInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"dining.inline"),React.createElement("g",{"id":"aa5b8b80-735f-4266-b919-6e912d2928db","data-name":"Layer 2","key":1},React.createElement("g",{"id":"ab263923-4895-4a68-967c-6ee62ec9d781","data-name":"Layer 1"},React.createElement("g",{"id":"eeb4512a-1636-41d3-9a2b-a8c1c7acb915","data-name":"dining.inline"},React.createElement("path",{"d":"M5.67.81V38.07M.81.81v8.1a4.86,4.86,0,0,0,9.72,0V.81m10.94,0C19.23.81,16.6,11.33,16.6,24.3h4.87m0-23.49V38.07","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.62"}))))]);
}

DiningInline.defaultProps = {"viewBox":"0 0 22.28 38.88"};

module.exports = DiningInline;

DiningInline.default = DiningInline;
